// extracted by mini-css-extract-plugin
export default {"wrapper":"ResendPassword_wrapper__cRgRc","button":"ResendPassword_button__TpN4o"};